import { useHistory, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { breakpoints } from '@etg/wings';
import { scrollToElement } from '../../utils/scrollToElement';

export const useScrollToElementViaQueryParams = (
  id: string | null,
  queryParam?: string,
  callback?: () => void,
) => {
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    if (queryParam) {
      const query = new URLSearchParams(location.search);
      if (query.get(queryParam) === 'true') {
        if (id) {
          const elementToScroll = document.querySelector(`#${id}`);
          if (elementToScroll) {
            const isMobileDevice = window.matchMedia(`(max-width: ${breakpoints._768})`).matches;
            const scrollToId = () =>
              scrollToElement(`#${id}`, isMobileDevice ? 71 : 79, 'smooth', !isMobileDevice);
            setTimeout(() => scrollToId(), 500);
          }
        }

        if (callback) {
          callback();
        }
        query.delete(queryParam);
        history.replace({
          search: query.toString(),
        });
      }
    }
  }, [history, id, queryParam, callback, location.search]);
};
